var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_329_773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.14286 0.214233C5.85402 0.214233 6.42857 0.788787 6.42857 1.49995V2.78566H11.5714V1.49995C11.5714 0.788787 12.146 0.214233 12.8571 0.214233C13.5683 0.214233 14.1429 0.788787 14.1429 1.49995V2.78566H16.0714C17.1362 2.78566 18 3.6495 18 4.71423V6.64281H0V4.71423C0 3.6495 0.863839 2.78566 1.92857 2.78566H3.85714V1.49995C3.85714 0.788787 4.4317 0.214233 5.14286 0.214233ZM0 7.92852H18V18.8571C18 19.9218 17.1362 20.7857 16.0714 20.7857H1.92857C0.863839 20.7857 0 19.9218 0 18.8571V7.92852ZM3.21429 10.4999C2.86071 10.4999 2.57143 10.7892 2.57143 11.1428V14.9999C2.57143 15.3535 2.86071 15.6428 3.21429 15.6428H7.07143C7.425 15.6428 7.71429 15.3535 7.71429 14.9999V11.1428C7.71429 10.7892 7.425 10.4999 7.07143 10.4999H3.21429Z",
    fill: "#D20F3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_329_773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20.5714,
    fill: "white",
    transform: "translate(0 0.214233)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar3);
export default __webpack_public_path__ + "static/media/calendar 3.bb25fca96f18292f01d66fdcada37ad3.svg";
export { ForwardRef as ReactComponent };